export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  categoryId: string;
  imageUrl: string;
  publishedAt: string;
  author: string;
  tags: string[];
  viewCount: number;
  isHot: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '某顶流男星深夜私会神秘女子，疑似新恋情曝光',
    slug: 'dingliu-nanxing-sihui-mimi-nvzi',
    excerpt: '近日有媒体拍到某当红男星深夜与一名神秘女子同行，两人举止亲密，引发网友热议。据知情人士透露，该女子并非圈内人，两人已秘密交往数月。',
    content: `<p>近日，知名娱记拍到国内一线男星李某某深夜现身北京某高档小区，身边还有一名神秘女子随行。两人一前一后进入小区，期间多次亲密交谈，关系看起来非同一般。</p>
    <p>据现场目击者透露，当晚大约11点半左右，李某某驾驶一辆黑色商务车抵达小区门口。随后一名身穿白色连衣裙的长发女子从副驾驶座下车，两人并肩走向单元楼入口。</p>
    <p>值得注意的是，李某某全程戴着口罩和帽子，显得十分谨慎。该女子则神情自然，似乎对小区环境非常熟悉。</p>
    <p>知情人爆料称，该女子姓王，今年25岁，是一名海归金融分析师，与李某某通过共同朋友介绍认识，目前已经秘密交往超过三个月。</p>
    <p>李某某工作室对此暂未作出回应。粉丝们对此反应不一，有的表示祝福，有的则质疑消息真实性。</p>
    <p>这已经不是李某某第一次被拍到与异性同行的画面。去年底，他曾被拍到与一位女演员共进晚餐，但当时工作室很快否认了恋情传闻。</p>
    <p>娱乐圈资深评论人张老师分析认为，如果恋情属实，李某某选择在事业上升期公开感情状态，或将对未来发展产生一定影响。</p>`,
    categoryId: 'yulequan',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mysterious%20night%20scene%20outside%20a%20luxury%20apartment%20complex%20in%20Beijing%2C%20a%20silhouette%20of%20a%20man%20and%20woman%20walking%20together%20under%20dim%20streetlights%2C%20cinematic%20mood%2C%20dark%20atmosphere%2C%20paparazzi%20style%20photography%2C%20warm%20yellow%20lighting&width=800&height=500&seq=article-1-img&orientation=landscape',
    publishedAt: '2026-08-07T14:30:00Z',
    author: '黑料小编',
    tags: ['顶流男星', '恋情曝光', '娱乐圈', '深夜约会'],
    viewCount: 128500,
    isHot: true,
  },
  {
    id: 'article-2',
    title: '知名网红直播带货翻车，产品质量遭集体投诉',
    slug: 'zhiming-wanghong-zhibo-fanche',
    excerpt: '拥有千万粉丝的某头部主播近日直播带货的一款美容仪被大量消费者投诉质量问题，涉及虚假宣传和售后推诿。消协已介入调查。',
    content: `<p>近日，拥有超过两千万粉丝的头部带货主播"雪梨姐姐"陷入产品质量风波。她在上月的直播中力推的某品牌家用美容仪，被大批消费者反映存在严重质量问题。</p>
    <p>据统计，截至目前已有超过500名消费者在各大平台发起投诉，主要问题包括：产品使用后出现皮肤过敏、仪器发热异常、使用一个月后无法正常开机等。</p>
    <p>更令消费者不满的是，品牌方的售后处理态度消极。有消费者反映，联系客服后要么石沉大海，要么以"使用不当"为由拒绝退换。</p>
    <p>"雪梨姐姐"在最新一次直播中被粉丝追问此事时，仅表示"正在与品牌方积极沟通"，并未给出明确解决方案，引发粉丝不满。</p>
    <p>中国消费者协会已经关注到此事，表示将依法介入调查。市场监管部门也已约谈相关企业负责人。</p>
    <p>业内人士指出，直播带货行业近年来发展迅猛，但监管相对滞后。主播在选品时应承担更多责任，不能只追求佣金收入而忽视产品质量。</p>`,
    categoryId: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20livestreaming%20studio%20with%20beauty%20products%20scattered%20on%20a%20table%2C%20dramatic%20lighting%20with%20red%20warning%20tones%2C%20a%20sense%20of%20controversy%20and%20scandal%2C%20professional%20product%20photography%20style%2C%20clean%20composition&width=800&height=500&seq=article-2-img&orientation=landscape',
    publishedAt: '2026-08-07T10:15:00Z',
    author: '黑料小编',
    tags: ['网红直播', '带货翻车', '产品质量', '消费者投诉'],
    viewCount: 96200,
    isHot: true,
  },
  {
    id: 'article-3',
    title: '某女星被曝片场耍大牌，全组人员苦不堪言',
    slug: 'nvxing-pianchang-shuadapai',
    excerpt: '据剧组内部人员爆料，某知名女演员在拍摄期间频繁迟到、随意修改剧本，甚至要求全组配合其个人行程，引发众怒。',
    content: `<p>近日，一位自称在某古装剧组工作的人员在网上发文，爆料该剧女主角在拍摄期间的种种不当行为，引发网友广泛讨论。</p>
    <p>据这位工作人员描述，该女演员在为期三个月的拍摄周期内，几乎每天都要迟到1-2小时。全剧组百余号人经常要在片场干等她一个人到场才能开工。</p>
    <p>更令人气愤的是，她经常在开拍前临时要求修改自己的戏份和对白，导致导演和编剧不得不现场重新调整剧本，严重影响了拍摄进度。</p>
    <p>此外，该女演员还被指要求剧组为其配备专属房车、私人化妆师和至少三名助理随行。据称这些要求并未写在合同中，属于临时追加。</p>
    <p>消息传出后，多位曾与该女演员合作过的圈内人纷纷发文暗示此事属实。一位知名导演也在社交平台发文称"演员最重要的不是演技，是人品"。</p>
    <p>截至发稿，该女演员及其工作室均未对此事作出回应。</p>`,
    categoryId: 'mingxing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20crew%20members%20waiting%20impatiently%2C%20empty%20director%20chair%20in%20the%20center%2C%20dramatic%20lighting%20with%20shadows%2C%20tense%20atmosphere%2C%20behind%20the%20scenes%20movie%20production%2C%20cinematic%20mood&width=800&height=500&seq=article-3-img&orientation=landscape',
    publishedAt: '2026-08-06T20:45:00Z',
    author: '黑料小编',
    tags: ['女明星', '耍大牌', '片场', '剧组黑幕'],
    viewCount: 185300,
    isHot: true,
  },
  {
    id: 'article-4',
    title: '某选秀节目被曝内部操作，淘汰名单早已内定',
    slug: 'xuanxiu-jiemu-neibu-caozuo',
    excerpt: '热门选秀节目再陷造假风波，前工作人员实名爆料称淘汰顺序早在录制前就已确定，所谓的投票只是走形式。',
    content: `<p>今年最受关注的一档音乐选秀节目近日被前工作人员实名爆料，称节目的淘汰机制存在严重造假行为，引发了社会各界的广泛关注。</p>
    <p>这位自称曾担任节目编导助理的爆料人表示，选手的去留实际上在节目录制前就已经由制作方和赞助商共同决定。所谓的"观众投票"和"导师选择"环节完全是为了节目效果而设计的表演。</p>
    <p>爆料人还提供了多张工作群的聊天记录截图作为证据，其中明确提到了"保送名单"和"淘汰名单"等字眼。</p>
    <p>这一爆料迅速在网络上引起轩然大波。多位被淘汰选手的粉丝表示愤怒，认为自己花费大量金钱投票是在"被骗"。</p>
    <p>节目组随后发布声明，否认所有指控，称爆料人因工作表现不佳被辞退后怀恨在心，其提供的所谓证据系伪造。</p>
    <p>广电总局相关人士表示，将对此类综艺节目的投票机制加强监管，确保公平公正。</p>`,
    categoryId: 'zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20talent%20show%20stage%20with%20spotlights%20and%20a%20contestant%20standing%20alone%2C%20dramatic%20contrast%20between%20bright%20stage%20and%20dark%20audience%2C%20sense%20of%20manipulation%20and%20scandal%2C%20theatrical%20lighting%2C%20professional%20photography&width=800&height=500&seq=article-4-img&orientation=landscape',
    publishedAt: '2026-08-06T16:00:00Z',
    author: '黑料小编',
    tags: ['选秀节目', '内定', '造假', '综艺黑幕'],
    viewCount: 154700,
    isHot: true,
  },
  {
    id: 'article-5',
    title: '当红歌手被前经纪人起诉，拖欠千万分成款项',
    slug: 'danghong-geshou-beisu-cheng',
    excerpt: '某当红流行歌手被前经纪人告上法庭，指控其恶意拖欠演出分成款累计超过1200万元。法院已正式立案。',
    content: `<p>据法院公开信息显示，知名流行歌手赵某被其前经纪人李某起诉至北京市朝阳区人民法院，案由为合同纠纷。</p>
    <p>起诉书显示，李某曾担任赵某的经纪人长达五年时间（2019年-2024年），期间负责其所有商业演出的接洽和谈判工作。按照双方签订的经纪合同约定，李某应获得每场演出收入的15%作为分成。</p>
    <p>然而，自2023年初开始，赵某开始以各种理由拖延支付分成款项。截至双方合作关系终止的2024年底，累计拖欠金额已达1200余万元。</p>
    <p>李某在诉状中称，曾多次通过微信、邮件等方式催要欠款，但赵某始终以"正在核实""资金周转困难"等理由搪塞。最后甚至指示其新经纪人拒绝与李某沟通。</p>
    <p>赵某工作室对此回应称，双方确实存在经济纠纷，但金额与李某所称存在较大出入，具体细节不便在开庭前公开。</p>
    <p>法律界人士分析认为，如果李某能够提供充分的合同和账目证据，胜诉的可能性较大。</p>`,
    categoryId: 'yinyue',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20courtroom%20scene%20with%20legal%20documents%20and%20a%20gavel%2C%20music%20notes%20fading%20in%20the%20background%2C%20dramatic%20lighting%2C%20professional%20photography%2C%20tense%20legal%20atmosphere&width=800&height=500&seq=article-5-img&orientation=landscape',
    publishedAt: '2026-08-06T09:30:00Z',
    author: '黑料小编',
    tags: ['歌手', '经纪人', '合同纠纷', '拖欠款项'],
    viewCount: 89200,
    isHot: false,
  },
  {
    id: 'article-6',
    title: '某热播剧女主被替，原定演员疑因得罪制片人被换角',
    slug: 'reboju-nvzhu-beiti',
    excerpt: '正在热播的都市情感剧女主角突然更换演员，引发观众不满。知情人透露，原定女主角因不愿配合制片方某些要求而被临时换人。',
    content: `<p>正在各大视频平台热播的都市情感剧《繁华都市》播出至第15集时，女主角突然更换演员，引发大量观众不满和质疑。</p>
    <p>据知情人透露，原定女主角由实力派演员陈某某饰演。陈某某在已经完成前20集拍摄的情况下，突然被告知后续戏份将由另一位女演员接替。</p>
    <p>消息人士称，陈某某被换的真正原因是多次拒绝制片方的某些不合理要求，包括配合剧组进行过度炒作以及参加一些与拍摄无关的商务应酬。</p>
    <p>制片方对外给出的解释是"演员档期冲突"，但这一说法显然与事实不符——陈某某的社交平台显示，她在被"换角"后的档期完全空闲。</p>
    <p>观众们对此非常不满，纷纷在平台评论区表达抗议：\"换人之后完全看不下去\"\"演技差距太大了，新女主完全没有陈某某的那种气场\"。</p>
    <p>影视行业人士表示，这种中途换角的情况虽然不常见，但背后往往涉及复杂的利益博弈。</p>`,
    categoryId: 'shipin',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20TV%20drama%20set%20with%20two%20actresses%2C%20one%20leaving%20and%20one%20arriving%2C%20dramatic%20lighting%2C%20emotional%20tension%2C%20behind%20the%20scenes%20of%20a%20Chinese%20TV%20production%2C%20professional%20cinematography&width=800&height=500&seq=article-6-img&orientation=landscape',
    publishedAt: '2026-08-05T22:00:00Z',
    author: '黑料小编',
    tags: ['热播剧', '换角', '制片方', '影视内幕'],
    viewCount: 112400,
    isHot: true,
  },
  {
    id: 'article-7',
    title: '知名男团成员涉嫌税务问题，补缴金额或超千万',
    slug: 'zhiming-nantuan-shuiwu-wenti',
    excerpt: '继多位明星陷入税务风波后，又一位知名男团成员被税务机关约谈。据悉其涉及多项收入未依法申报纳税。',
    content: `<p>据税务系统知情人士透露，国内某当红男团的核心成员王某近日被主管税务机关约谈，要求其就多项收入未依法申报纳税的情况进行说明。</p>
    <p>据了解，王某在过去三年间通过品牌代言、商业演出、综艺节目录制等渠道获得了大量收入，但其中相当一部分未按规定进行纳税申报。</p>
    <p>税务机关初步核查后发现，涉及未申报的收入金额可能高达数千万元，按照相关税率计算，需补缴税款及滞纳金总额预计超过1000万元。</p>
    <p>消息传出后，王某的粉丝群体陷入恐慌，纷纷在其社交平台留言询问情况。但王某及其工作室均保持沉默。</p>
    <p>税务专家指出，近年来税务部门对文娱行业高收入人群的监管力度明显加强，艺人应当提高纳税意识，避免因小失大。</p>`,
    categoryId: 'mingxing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxury%20office%20with%20tax%20documents%20and%20calculator%20on%20a%20desk%2C%20dramatic%20shadows%2C%20a%20sense%20of%20financial%20trouble%2C%20professional%20photography%2C%20warm%20dark%20tones&width=800&height=500&seq=article-7-img&orientation=landscape',
    publishedAt: '2026-08-05T15:00:00Z',
    author: '黑料小编',
    tags: ['男团', '税务问题', '偷税漏税', '明星财务'],
    viewCount: 201500,
    isHot: true,
  },
  {
    id: 'article-8',
    title: '网红餐厅被曝使用过期食材，后厨卫生状况触目惊心',
    slug: 'wanghong-canting-guoqi-shicai',
    excerpt: '一家在社交平台拥有百万粉丝的网红餐厅被前员工爆料后厨使用过期食材，卫生状况堪忧。市场监管部门已展开调查。',
    content: `<p>近日，一位自称曾在某网红餐厅工作三个月的后厨人员在社交平台发布了一系列令人触目惊心的照片和视频，曝光了该餐厅后厨的真实情况。</p>
    <p>根据爆料内容，这家以"健康轻食"为卖点的网红餐厅，实际上大量使用过期的肉类和蔬菜。厨师被要求在食材已经明显变质的情况下，通过加重调味来掩盖异味。</p>
    <p>更令人震惊的是，该餐厅的后厨卫生状况极差——蟑螂横行、油烟管道常年不清洗、生熟食品混放、员工直接用手处理食材而没有佩戴手套。</p>
    <p>该爆料迅速在网络上引发热议，许多曾在该餐厅消费过的网友纷纷表示"恶心""后怕"。有网友称自己和朋友在该餐厅用餐后曾出现腹泻症状。</p>
    <p>当地市场监管部门在接到举报后已于当日下午对该餐厅进行了突击检查，目前餐厅已被责令停业整顿。</p>`,
    categoryId: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20messy%20restaurant%20kitchen%20with%20expired%20food%20ingredients%2C%20dirty%20surfaces%2C%20dramatic%20exposure%20style%20photography%2C%20investigative%20journalism%20aesthetic%2C%20dark%20and%20gritty%20atmosphere&width=800&height=500&seq=article-8-img&orientation=landscape',
    publishedAt: '2026-08-05T10:00:00Z',
    author: '黑料小编',
    tags: ['网红餐厅', '食品安全', '过期食材', '后厨卫生'],
    viewCount: 176800,
    isHot: true,
  },
  {
    id: 'article-9',
    title: '某导演被多名女演员指控性骚扰，已有多人站出指证',
    slug: 'daoyan-xingsaorao-zhikong',
    excerpt: '娱乐圈再爆丑闻！某知名导演被至少五名女演员公开指控在合作期间存在不当行为，包括言语骚扰和肢体接触。',
    content: `<p>娱乐圈性骚扰丑闻持续发酵。继多位女演员勇敢站出来揭露行业潜规则后，又一名知名导演被推上风口浪尖。</p>
    <p>截至目前，已有至少五名曾与该导演合作过的女演员公开发声，指控其在工作场合存在不同程度的性骚扰行为。指控内容包括不当的肢体接触、带有性暗示的言语骚扰，以及以选角为由提出不正当要求。</p>
    <p>其中一名女演员详细描述了自己在试镜过程中遭遇的经历：\"他让我在他面前换衣服，说是要看看身材是否符合角色要求。我当时才22岁，非常害怕，根本不知道该怎么拒绝。\"</p>
    <p>该导演通过律师发表声明，全盘否认所有指控，称这些指控是\"有组织的恶意诽谤\"，并表示将通过法律途径维护自身权益。</p>
    <p>多家影视公司已宣布在调查结果出来之前，暂停与该导演的所有合作项目。</p>`,
    categoryId: 'yulequan',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20silhouette%20of%20a%20person%20standing%20alone%20on%20a%20dark%20stage%20with%20a%20single%20spotlight%2C%20dramatic%20and%20solemn%20atmosphere%2C%20the%20weight%20of%20speaking%20out%2C%20cinematic%20lighting%2C%20professional%20photography&width=800&height=500&seq=article-9-img&orientation=landscape',
    publishedAt: '2026-08-04T18:30:00Z',
    author: '黑料小编',
    tags: ['导演', '性骚扰', '女演员', '娱乐圈丑闻'],
    viewCount: 258300,
    isHot: true,
  },
  {
    id: 'article-10',
    title: '音乐节天价票被指割韭菜，实际阵容与宣传严重不符',
    slug: 'yinyuejie-tianjiapiao-gediaojiucai',
    excerpt: '某大型音乐节售票引发争议，宣传海报上的多位重磅嘉宾实际并未签约，消费者直呼上当。票价从399元飙升至1299元。',
    content: `<p>今年最受期待的某大型户外音乐节近日因门票问题陷入争议。消费者反映，宣传海报上出现的多位国际知名艺人实际上并未与主办方签约。</p>
    <p>据了解，该音乐节在早期宣传中打出了包括三位格莱美获奖者在内的豪华阵容，预售票在48小时内售罄。然而，随着演出日期临近，主办方悄然更换了宣传物料，最初宣传的多位重磅嘉宾从海报上消失了。</p>
    <p>更令消费者不满的是，音乐节的票价从去年的399元飙升至1299元，涨幅超过三倍。但实际公布的最终阵容与宣传时的"豪华阵容"相去甚远。</p>
    <p>多位购票者表示要求退票，但被主办方以"票务一经售出概不退换"为由拒绝。目前已有消费者联合向消协投诉。</p>
    <p>业内人士分析认为，近年来音乐节市场火热，但也出现了不少"割韭菜"的现象，消费者在购票时应保持理性。</p>`,
    categoryId: 'yinyue',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20music%20festival%20stage%20with%20disappointing%20small%20crowd%2C%20empty%20spaces%2C%20overcast%20sky%2C%20a%20sense%20of%20letdown%20and%20disappointment%2C%20professional%20event%20photography%2C%20moody%20atmosphere&width=800&height=500&seq=article-10-img&orientation=landscape',
    publishedAt: '2026-08-04T14:00:00Z',
    author: '黑料小编',
    tags: ['音乐节', '票价', '虚假宣传', '消费者维权'],
    viewCount: 95400,
    isHot: false,
  },
  {
    id: 'article-11',
    title: '某综艺常驻嘉宾因不当言论被剪掉全部镜头',
    slug: 'zongyi-jiabin-budang-yanlun',
    excerpt: '一档热门综艺的常驻嘉宾在录制现场发表了涉及敏感话题的不当言论，节目组连夜将其所有镜头全部删除。',
    content: `<p>据综艺节目内部人士透露，某热门综艺节目的常驻嘉宾在最新一期录制过程中，在未与节目组沟通的情况下，突然发表了涉及敏感社会议题的不当言论。</p>
    <p>该言论在现场引发了尴尬的沉默，其他嘉宾和现场观众都显得不知所措。导演组立即叫停了录制，并与该嘉宾进行了紧急沟通。</p>
    <p>最终，节目组决定将该嘉宾在本期节目中的所有镜头全部删除。后期团队连夜加班重新剪辑，以确保节目能够如期播出。</p>
    <p>该嘉宾随后在社交平台发文道歉，称自己"一时口快，没有考虑周全"，但网友似乎并不买账。有网友翻出其此前的多段争议言论，质疑其"屡教不改"。</p>
    <p>据悉，节目组正在考虑更换常驻嘉宾，以维护节目的正面形象。</p>`,
    categoryId: 'zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20TV%20studio%20with%20empty%20chairs%20and%20cameras%2C%20one%20chair%20removed%20from%20the%20set%2C%20dramatic%20lighting%2C%20a%20sense%20of%20someone%20being%20erased%2C%20professional%20broadcast%20environment&width=800&height=500&seq=article-11-img&orientation=landscape',
    publishedAt: '2026-08-04T09:00:00Z',
    author: '黑料小编',
    tags: ['综艺节目', '不当言论', '嘉宾', '剪辑'],
    viewCount: 143200,
    isHot: false,
  },
  {
    id: 'article-12',
    title: '影视圈又爆阴阳合同，某演员实际片酬与申报金额相差巨大',
    slug: 'yingshiquan-yinyang-hetong',
    excerpt: '税务部门在例行检查中发现，某一线男演员通过阴阳合同方式隐藏真实片酬，实际收入与申报金额差额高达数千万元。',
    content: `<p>近日，国家税务总局在一次针对文娱行业高收入人群的专项检查中，发现某一线男演员存在利用"阴阳合同"逃避税款的行为。</p>
    <p>检查结果显示，该演员在2024年拍摄的一部古装剧中，对外公布的片酬为800万元，但实际到手的金额超过5000万元。差额部分通过与剧组签订的多份"补充协议"以"艺术指导费""剧本顾问费"等名义发放。</p>
    <p>税务部门还发现，该演员名下注册了多家个人工作室和文化公司，通过复杂的关联交易将个人劳务报酬转化为企业收入，进一步降低适用税率。</p>
    <p>目前，税务部门已向该演员发出税务事项通知书，要求其限期补缴税款及滞纳金，并处以罚款。据初步估算，三项合计可能超过3000万元。</p>
    <p>这已经不是影视圈第一次爆出阴阳合同问题。业内人士呼吁，应建立更加透明的片酬公示制度。</p>`,
    categoryId: 'shipin',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20contracts%20side%20by%20side%20on%20a%20luxury%20desk%2C%20one%20visible%20and%20one%20hidden%20in%20shadow%2C%20dramatic%20lighting%2C%20legal%20documents%2C%20professional%20photography%2C%20sense%20of%20secrecy&width=800&height=500&seq=article-12-img&orientation=landscape',
    publishedAt: '2026-08-03T20:00:00Z',
    author: '黑料小编',
    tags: ['阴阳合同', '片酬', '税务', '影视圈'],
    viewCount: 167900,
    isHot: true,
  },
  {
    id: 'article-13',
    title: '某网红被扒出学历造假，自称名校毕业实为高中肄业',
    slug: 'wanghong-xueli-zaojia',
    excerpt: '拥有数百万粉丝的美妆博主被网友扒出其声称的某985高校学历纯属编造，真实学历仅为高中肄业。该博主已关闭评论区。',
    content: `<p>近日，拥有超过300万粉丝的美妆博主"小鹿美妆"陷入学历造假风波。有网友通过学信网和其他公开渠道核实后发现，其一直对外宣称的某知名985高校本科学历纯属虚构。</p>
    <p>据悉，"小鹿美妆"在多期视频和直播中均提到自己是XX大学（一所知名985高校）的毕业生，并经常以此为卖点增强自身专业度和可信度。她还多次分享所谓"大学时期的趣事"，塑造出一个高学历美妆专家的形象。</p>
    <p>然而，有细心的网友发现她在一次直播中连自己所称专业的核心课程名称都说错，从而引发质疑。随后的深度扒皮证实，她实际上高中未毕业就辍学了，从未进入过任何高等院校学习。</p>
    <p>事件发酵后，"小鹿美妆"关闭了所有社交平台的评论区，并删除了所有与学历相关的内容。但她并未发布任何致歉声明。</p>
    <p>多个与其合作的品牌方已经紧急下架了相关宣传物料，部分品牌甚至宣布终止合作。</p>`,
    categoryId: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20beauty%20influencer%20studio%20setup%20with%20makeup%20products%2C%20a%20diploma%20torn%20in%20half%20in%20the%20foreground%2C%20dramatic%20contrast%2C%20professional%20photography%2C%20warm%20lighting%20with%20shadows&width=800&height=500&seq=article-13-img&orientation=landscape',
    publishedAt: '2026-08-03T13:00:00Z',
    author: '黑料小编',
    tags: ['网红', '学历造假', '人设崩塌', '美妆博主'],
    viewCount: 142600,
    isHot: true,
  },
  {
    id: 'article-14',
    title: '某知名制片人被曝婚内出轨，与多名女演员存在不正当关系',
    slug: 'zhipianren-hunnei-chugui',
    excerpt: '娱乐圈知名制片人张某被妻子公开指控婚内出轨，据称其与至少三名女演员保持不正当关系长达数年。',
    content: `<p>娱乐圈再爆婚变丑闻。知名制片人张某的妻子在社交平台发布长文，公开指控其丈夫在婚姻存续期间与多名女演员存在不正当关系。</p>
    <p>在这篇长达3000字的文章中，张某的妻子详细列举了丈夫出轨的证据，包括酒店开房记录、暧昧聊天截图以及多名知情人的证言。据称，张某与至少三名女演员在不同时间段保持不正当关系，最早的一段可以追溯到五年前。</p>
    <p>文章发布后迅速引发全网关注。其中一位被点名的女演员火速发表声明否认，称将采取法律手段维权。另外两位则保持沉默。</p>
    <p>张某本人至今未对此事作出公开回应。但有媒体拍到他在事件爆发后匆忙离开北京，疑似前往国外避风头。</p>
    <p>圈内人士表示，娱乐圈中制片人与演员之间权力不对等的关系，容易滋生此类问题。呼吁行业建立更完善的职业规范。</p>`,
    categoryId: 'yulequan',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20wedding%20ring%20lying%20on%20a%20script%20with%20dramatic%20lighting%2C%20a%20sense%20of%20betrayal%20and%20scandal%2C%20cinematic%20photography%2C%20dark%20atmosphere%2C%20professional%20composition&width=800&height=500&seq=article-14-img&orientation=landscape',
    publishedAt: '2026-08-03T08:30:00Z',
    author: '黑料小编',
    tags: ['制片人', '婚内出轨', '娱乐圈', '丑闻'],
    viewCount: 221400,
    isHot: true,
  },
  {
    id: 'article-15',
    title: '选秀出道男团成员疑因感情纠纷在酒吧大打出手',
    slug: 'nantuan-chengyuan-ganqing-jiufen',
    excerpt: '某选秀出道男团成员被拍到在酒吧与人大打出手，据称起因是感情纠纷。该成员事后被警方带走问话。',
    content: `<p>近日，有网友在社交平台上传了一段视频，显示某选秀出道的男团成员在酒吧内与另一名男子发生激烈冲突，场面一度失控。</p>
    <p>视频画面中可以看到，该男团成员先是与对方发生口角，随后情绪激动地冲上前去推搡对方，双方很快扭打在一起。酒吧工作人员和同行友人试图拉开两人，但场面一度非常混乱。</p>
    <p>据现场目击者称，冲突的起因是该男团成员发现自己的女友与另一名男子在酒吧举止亲密，一怒之下上前理论，进而演变成肢体冲突。</p>
    <p>警方接警后赶到现场，将双方带回派出所问话。据知情人士透露，经调解后双方已达成和解，未造成严重后果。</p>
    <p>该男团所属经纪公司随后发表声明，称艺人对自己的冲动行为深感抱歉，将暂停其近期所有公开活动进行反思。</p>`,
    categoryId: 'mingxing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20bar%20interior%20with%20broken%20glass%20on%20the%20floor%2C%20dramatic%20lighting%2C%20a%20sense%20of%20conflict%20and%20chaos%2C%20nightlife%20photography%2C%20atmospheric%20mood&width=800&height=500&seq=article-15-img&orientation=landscape',
    publishedAt: '2026-08-02T23:00:00Z',
    author: '黑料小编',
    tags: ['男团', '打架', '酒吧', '感情纠纷'],
    viewCount: 188700,
    isHot: false,
  },
  {
    id: 'article-16',
    title: '综艺节目导演被指虐待选手，高压训练致多人受伤',
    slug: 'zongyi-daoyan-nuedai-xuanshou',
    excerpt: '某竞技类综艺节目被曝训练强度过大，多名选手在高压训练中受伤，有参赛者声称导演为追求节目效果不顾选手安危。',
    content: `<p>一档以高强度竞技为卖点的综艺节目近日被多名参赛选手联合控诉，称节目组在训练和录制过程中存在虐待选手的行为。</p>
    <p>据一位不愿透露姓名的参赛者描述，节目组要求选手在高温天气下进行长达数小时的户外体能训练，期间不提供充足的饮水。多名选手出现中暑、脱水等症状，但导演以"追求真实效果"为由拒绝暂停拍摄。</p>
    <p>医疗记录显示，至少有六名参赛选手在录制期间因不同程度的伤病就医治疗，包括肌肉拉伤、关节扭伤、严重晒伤等，其中一名选手甚至因过度疲劳导致心律不齐。</p>
    <p>节目组对此回应称，所有训练项目均在专业教练指导下进行，选手的安全是节目组的首要考虑。对于相关指控，节目组表示"与事实不符"。</p>
    <p>广电部门表示已关注到相关舆情，将对节目制作的安全性进行评估。</p>`,
    categoryId: 'zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20intense%20sports%20training%20facility%20with%20exhausted%20athletes%2C%20dramatic%20lighting%2C%20a%20sense%20of%20struggle%20and%20exhaustion%2C%20professional%20sports%20photography%2C%20gritty%20atmosphere&width=800&height=500&seq=article-16-img&orientation=landscape',
    publishedAt: '2026-08-02T16:00:00Z',
    author: '黑料小编',
    tags: ['综艺节目', '虐待选手', '受伤', '高强度训练'],
    viewCount: 133500,
    isHot: false,
  },
  {
    id: 'article-17',
    title: '某歌手新歌被指抄袭，旋律与海外作品高度相似',
    slug: 'geshou-xinge-chaoxi',
    excerpt: '乐坛再起抄袭争议。某知名歌手发布的新歌被网友扒出旋律与一首海外小众歌曲高度相似，专业人士给出对比分析。',
    content: `<p>近日，知名歌手陈某发布的新单曲《星辰》在上线首日便取得了百万播放量，但随之而来的却是一场抄袭风波。</p>
    <p>有网友发现，《星辰》的副歌旋律与一首三年前发布的海外小众独立音乐人的作品《Starlight》惊人相似。通过专业音频软件对比，两首歌曲的副歌部分在旋律走向、和弦进行以及节奏型上高度重合。</p>
    <p>多位音乐制作人也在社交平台发声，从专业角度分析了这两首歌的相似之处。一位资深音乐人表示：\"在音乐创作中，偶尔的巧合是有可能的，但如此大段的旋律高度一致，很难用'巧合'来解释。\"</p>
    <p>陈某的团队随后发表声明，称《星辰》完全为原创作品，所有的雷同纯属巧合，并表示将通过法律手段维护名誉。</p>
    <p>原创音乐人方面目前尚未作出回应。但该事件已经在海外音乐社区引发关注，有粉丝已将对比视频翻译成英文上传至多个平台。</p>`,
    categoryId: 'yinyue',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20musical%20scores%20side%20by%20side%20with%20highlighted%20similar%20sections%2C%20dramatic%20lighting%2C%20a%20sense%20of%20comparison%20and%20controversy%2C%20professional%20photography%2C%20clean%20composition&width=800&height=500&seq=article-17-img&orientation=landscape',
    publishedAt: '2026-08-02T10:30:00Z',
    author: '黑料小编',
    tags: ['歌手', '抄袭', '新歌', '音乐版权'],
    viewCount: 118900,
    isHot: false,
  },
  {
    id: 'article-18',
    title: '知名导演新片票房惨败，疑因得罪院线被减少排片',
    slug: 'daoyan-xinpian-piaofang-canbai',
    excerpt: '曾获多项大奖的知名导演最新力作上映首周票房惨淡。有业内人士指出，该导演因拒绝院线不合理要求而遭到排片打压。',
    content: `<p>曾执导过多部票房口碑双丰收作品的知名导演刘某，其最新力作《归途》上映首周票房仅收830万元，与市场预期相去甚远。</p>
    <p>然而，令人费解的是，该片在豆瓣的评分高达8.2分，远高于同期上映的多部商业大片。观众口碑与票房表现的巨大反差引发了业内的广泛讨论。</p>
    <p>有不愿意透露姓名的业内人士向媒体透露，刘导的《归途》遭遇了院线的"隐性封杀"。据称，在影片上映前，多家大型院线要求刘导在合同中加入不合理的票房对赌条款，被刘导断然拒绝。作为报复，院线方面大幅减少了该片的排片场次。</p>
    <p>数据显示，《归途》在全国范围内的排片占比仅为3.7%，远低于同类影片的平均水平。而且在黄金时段的场次几乎为零，大部分排片都集中在工作日的上午和深夜时段。</p>
    <p>院线方面否认存在排片打压行为，称排片策略完全基于市场预期和预售数据决定。</p>`,
    categoryId: 'shipin',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20empty%20movie%20theater%20with%20red%20seats%2C%20a%20movie%20poster%20on%20the%20wall%2C%20dramatic%20lighting%2C%20a%20sense%20of%20disappointment%2C%20professional%20cinema%20photography%2C%20atmospheric%20mood&width=800&height=500&seq=article-18-img&orientation=landscape',
    publishedAt: '2026-08-01T20:00:00Z',
    author: '黑料小编',
    tags: ['导演', '票房', '院线', '排片'],
    viewCount: 105600,
    isHot: false,
  },
  {
    id: 'article-19',
    title: '某网红情侣分手撕破脸，互曝隐私引发网络骂战',
    slug: 'wanghong-qinglv-fenshou',
    excerpt: '曾被誉为"神仙眷侣"的一对网红情侣突然宣布分手，随后双方在社交平台互相指责，曝光了大量隐私内容。',
    content: `<p>曾拥有超过800万共同粉丝的网红情侣"阿杰和糖糖"近日宣布分手，随即在网络上掀起了一场惊涛骇浪。</p>
    <p>分手消息公布仅两小时后，女方"糖糖"在社交平台发布长文，指控"阿杰"在恋爱期间多次出轨、撒谎成性，并曝光了大量聊天记录截图作为证据。</p>
    <p>男方"阿杰"随即反击，晒出了女方的多笔大额消费记录，指责其"拜金""挥霍"，声称自己在这段关系中投入了超过200万元。</p>
    <p>双方的粉丝迅速分成两大阵营，在网络上展开激烈对骂。两人的话题连续两天占据热搜榜前三名。</p>
    <p>多位圈内人士呼吁双方停止公开互撕，保护彼此的隐私。但截至目前，双方的"战争"仍在持续升级，更多的隐私内容不断被曝出。</p>`,
    categoryId: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20broken%20heart%20shaped%20object%20on%20a%20smartphone%20screen%20with%20social%20media%20notifications%2C%20dramatic%20lighting%2C%20a%20sense%20of%20breakup%20and%20conflict%2C%20modern%20digital%20lifestyle%20photography&width=800&height=500&seq=article-19-img&orientation=landscape',
    publishedAt: '2026-08-01T14:00:00Z',
    author: '黑料小编',
    tags: ['网红情侣', '分手', '互撕', '隐私'],
    viewCount: 312500,
    isHot: true,
  },
  {
    id: 'article-20',
    title: '娱乐圈知名经纪人被拘，涉嫌组织艺人进行非法交易',
    slug: 'jingjiren-beiju-feifa-jiaoyi',
    excerpt: '警方破获一起涉及娱乐圈的案件，某知名经纪人因涉嫌组织旗下艺人从事非法交易被刑事拘留，案件正在进一步侦办中。',
    content: `<p>据警方通报，北京市公安局近日破获一起涉及文娱行业的案件，某知名娱乐公司经纪人王某因涉嫌组织卖淫罪被依法刑事拘留。</p>
    <p>通报显示，王某利用其经纪人身份，长期为多名影视投资人、企业高管等"高端客户"介绍旗下年轻艺人，组织所谓的"私人聚会"和"商务应酬"，实为非法交易。</p>
    <p>警方表示，经过长达半年的侦查，掌握了大量确凿证据，包括转账记录、聊天记录以及多名涉案人员的证词。目前案件正在进一步深挖中。</p>
    <p>消息传出后，该经纪公司紧急发表声明，称已与王某解除劳动关系，并表示将全力配合警方调查。</p>
    <p>此案在娱乐圈引发巨大震动。多位业内人士呼吁，应加强行业自律，杜绝此类事件再次发生。同时，也应关注年轻艺人的合法权益保护问题。</p>`,
    categoryId: 'yulequan',
    imageUrl: 'https://readdy.ai/api/search-image?query=Police%20handcuffs%20on%20a%20desk%20with%20entertainment%20industry%20contracts%20in%20the%20background%2C%20dramatic%20lighting%2C%20crime%20scene%20investigation%20aesthetic%2C%20professional%20photography%2C%20dark%20atmosphere&width=800&height=500&seq=article-20-img&orientation=landscape',
    publishedAt: '2026-08-01T08:00:00Z',
    author: '黑料小编',
    tags: ['经纪人', '刑拘', '非法交易', '娱乐圈'],
    viewCount: 276900,
    isHot: true,
  },
];